<script>
    import { scaleLinear } from 'd3-scale';
    import { dateParser } from '../utils/d3-utils';

    // components
    import Band from './Band.svelte';
    import MiniMap from './MiniHydroMap.svelte';

    export let data;
    export let region;
    export let legendTitle;
    export let width;

    let regions = [
        'Statewide',
        'North Coast',
        'Sacramento River',
        'North Lahontan',
        'San Francisco Bay',
        'San Joaquin River',
        'Central Coast',
        'Tulare Lake',
        'South Lahontan',
        'South Coast',
        'Colorado River'
    ]

    $: selectedRegion = region;

    let answer = '';

    function handleSubmit() {
        alert(`change regions`);
    }

    data.map((d) => {
        d.date = dateParser(d.date);
        return d;
    });

    $: filteredData = data.filter((d) => 
        d.hydrologic_region == selectedRegion
    );


    let marginTop = 0;
    let marginRight = 5;
    let marginBottom = 20;
    let marginLeft = 0;

    // set pill height
    let pillHeight = 40;
    let rowPadding = 10;

    // set height based on number of water years in the data
    let height = pillHeight + rowPadding;

    // group the data by water year

	$: group = '';
	$: groups = filteredData.reduce((curr, val) => {
        group = curr.find(g => g.water_year === `${val.water_year}`)
        if (group) {
            group.values.push(val)
        } else {
            curr.push({ water_year: `${val.water_year}`, values: [ val ] }) 
        }
        return curr
    }, []);

    // colors
    let precipColorScheme = [
        // '#c8a02d',
        // '#e9cb6f',
        // '#f0dfa3',

        '#efefefaa', // 0 inches
        '#d9eff4', // 0.01
        '#90d1e2', // 0.5
        '#3996b7', // 1
        '#056e90', // 1.5

        '#bba1c7', // 2
        '#ab7fb4', // 2.5
        '#8e679e', // 3

        '#b65a27', // 3.5
        '#dc6f26', // 4
    ];

    const precip_domain = [0, 0.01, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4];

    let colorScheme = scaleLinear()
        .domain(precip_domain)
        .range(precipColorScheme);

    // set up 'show more' button
    let limit = 6;
    let showAll = false;
    function onToggle() {
        showAll = !showAll;
    }
</script>

<div class="toggle-container">
    <form on:submit|preventDefault={handleSubmit}>
        <label for="region-dropdown" class="formation note">Choose a region:</label>
        <select id="region-dropdown" bind:value={region} on:change={() => (answer = '')}>
            {#each regions as r}
                <option value={r}>
                    {r}
                </option>
            {/each}
        </select>
    </form>

    <MiniMap
        bind:region={region}
    />
</div>

<div class="hm-legend-wrapper">
    <div class="hm-legend">
        {#if legendTitle}
            <h4>{legendTitle}</h4>
        {/if}
    
        <div class="legend-pills">
            {#each precip_domain as c, idx}
                <div class="legend-pill" style="background-color: {colorScheme(precip_domain[idx])}"></div>
            {/each}
        </div>
        <div class="legend-labels">
            {#each precip_domain as c, idx}
                <div class="legend-label">{c}</div>
            {/each}
        </div>    
    </div>
</div>

<div class="hm-chart inner-container" bind:clientWidth={width}>
    {#each groups as group, idx}
        <Band
            includeAxis={ idx == 0 ? true : false }
            data={group}
            waterYear={group.water_year}
            colors={colorScheme}
            width={width}
            display={(idx + 1 > limit && !showAll) ? 'display-none' : ''}
        />
    {/each}  
    <button class="btn" on:click={onToggle}>
        {showAll ? 'Show less' : 'Show all years'}
    </button>   
</div>